// extracted by mini-css-extract-plugin
export default {"root":"ProductImage_root__gbrMw"};